import { useEffect, useState } from "react";
import type { AuthMeDTO } from "@tendvia/shared";
import { api } from "./api";
import { AppShell } from "./screens/AppShell";
import { AuthScreen } from "./screens/AuthScreen";
import { ProfileSetupScreen } from "./screens/ProfileSetupScreen";
import { Harbor } from "./screens/Harbor";

export function App() {
  const [me, setMe] = useState<AuthMeDTO | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    void api.me()
      .then(setMe)
      .catch(() => setMe(null))
      .finally(() => setLoading(false));
  }, []);

  if (window.location.pathname.startsWith("/harbor")) {
    return <Harbor />;
  }

  if (loading) {
    return (
      <main className="grid min-h-screen place-items-center bg-background px-4 text-text">
        <p className="rounded-pill border border-border/60 bg-surface px-4 py-3 text-sm font-bold shadow-soft">Loading TendVia</p>
      </main>
    );
  }

  if (!me) return <AuthScreen onAuthed={setMe} />;
  if (!me.user.name || !me.organization.onboardingCompletedAt) {
    return <ProfileSetupScreen me={me} onSaved={(nextMe) => setMe(nextMe)} />;
  }
  return <AppShell me={me} onLogout={() => setMe(null)} />;
}
